import { Row, Col } from "antd";
import React from "react";
import WeaHelpfulTip from "../wea-helpful-tip";
import middleware from "../../middleware";

class SearchGroup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showGroup: props.showGroup || false
    };
  }
  componentWillReceiveProps(nextProps) {
    // needUpdateShowGroupStatus 控制 componentWillReceiveProps 是否更新showGroup的值
    if (
      "showGroup" in nextProps &&
      "needUpdateShowGroupStatus" in nextProps &&
      nextProps.needUpdateShowGroupStatus &&
      this.state.showGroup !== nextProps.showGroup
    ) {
      this.setState({ showGroup: nextProps.showGroup });
    }
  }

  onAdSearch() {
    // 支持高级搜索内input框的onEnter触发搜索
    const { onAdSearch } = this.props;
    typeof onAdSearch === "function" && onAdSearch();
  }

  render() {
    const {
      ecId,
      title,
      items,
      needTigger = true,
      col = 2,
      customComponent = "",
      children,
      fontSize,
      style = {},
      center,
      size,
      hide,
      multiCol,
      titleTip = null
    } = this.props;
    const { showGroup } = this.state;
    return (
      <div
        className={`wea-search-group ${this.props.className || ""} ${
          hide ? "wea-hide" : "wea-show"
        }`}
        style={style}
      >
        {title && (
          <Row ecId={`${ecId}_Row@gkjv8p`} className="wea-title">
            <Col
              ecId={`${ecId}_Col@582gf1`}
              span={customComponent === "" ? (needTigger ? 23 : 24) : 10}
            >
              <div style={{ fontSize }} className="wea-f12 text-elli">
                {title}
                {titleTip && (
                  <span style={{ "margin-left": "5px" }}>
                    <WeaHelpfulTip
                      {...titleTip}
                      ecId={`${ecId}_WeaHelpfulTip@6du397`}
                    />
                  </span>
                )}
              </div>
            </Col>
            {customComponent && (
              <Col
                ecId={`${ecId}_Col@qmsq8r`}
                className={"wea-f12"}
                span={needTigger ? 13 : 14}
                style={{ textAlign: "right", paddingRight: 10 }}
              >
                {customComponent}
              </Col>
            )}
            {needTigger && (
              <Col
                ecId={`${ecId}_Col@gzrxfj`}
                className={"wea-f12"}
                span={1}
                style={{ textAlign: "right", paddingRight: 10 }}
              >
                <i
                  ecId={`${ecId}_i@4y1obt`}
                  className={showGroup ? "icon-coms-up" : "icon-coms-down"}
                  onClick={() => {
                    this.setState({ showGroup: !showGroup });
                    this.props.onVisibleChange &&
                      this.props.onVisibleChange(!showGroup);
                  }}
                />
              </Col>
            )}
          </Row>
        )}
        <Row
          ecId={`${ecId}_Row@ipqua7`}
          className={`wea-content ${center ? "center" : ""} ${
            multiCol ? "multiCol" : ""
          } ${title ? "pt15" : ""}`}
          style={showGroup ? {} : { display: "none" }}
        >
          <div className={`wea-form-cell-wrapper clearfix  ${size || ""}`}>
            {items &&
              items.map((obj, index) => {
                if (obj) {
                  let cellNum = obj.col || col;
                  if (center) cellNum = 1;
                  return (
                    <Col
                      ecId={`${ecId}_Col@z9kzzo@${index}`}
                      className={`wea-form-cell ${obj.hide ? "wea-hide" : ""}`}
                      span={24 / cellNum}
                    >
                      {/* {obj.com &&
                        (obj.com.type
                          ? React.cloneElement(obj.com, {
                              onAdSearch: this.onAdSearch.bind(this)
                            })
                          : obj.com)} */}
                      {obj.com}
                    </Col>
                  );
                }
              })}
            {children}
          </div>
        </Row>
      </div>
    );
  }
}

const Com = middleware(SearchGroup, "WeaSearchGroup");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-search-group/index.js